import { groq } from 'next-sanity'
import { seoFields } from '@otomoro/sanity/lib/queries/partials/shared'

export const contactPageQuery = groq`*[_type == "contactPage" && language == "en"][0] {
  ...,
  pageTitle,
	headline,
	subHeadline,
  introTag,
	introduction,
	contactSubjects,
	address,
	email,
	phone,
  ${seoFields}
}`

export const contactPageSeoQuery = groq`*[_type == "contactPage" && language == "en"][0]{
  ${seoFields}
}`
